import React, { useCallback, useMemo, useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { ButtonPrimary } from '../../../components/Button'
import Modal, { ModalProps } from '../../../components/bakery/Modal'
import ModalActions from '../../../components/bakery/ModalActions'
import ModalTitle from '../../../components/bakery/ModalTitle'
import TokenInput from '../../../components/bakery/TokenInput'
import { getFullDisplayBalance } from '../../../utils/bakery/formatBalance'
import { MINTTOKEN } from '../../../constants/bakery'

const Button = styled(ButtonPrimary)`
  font-family: Baloo Da;
  height: 48px;
  padding: 0;
`

interface DepositModalProps extends ModalProps {
  max: BigNumber
  onConfirm: (amount: string) => void
  tokenName?: string
  integer?: boolean
}

const DepositModal: React.FC<DepositModalProps> = ({
  max,
  onConfirm,
  onDismiss,
  tokenName = '',
  integer = false
}) => {
  const [val, setVal] = useState('')
  const [pendingTx, setPendingTx] = useState(false)

  const fullBalance = useMemo(() => {
    if (tokenName === MINTTOKEN.ALICE) {
      return getFullDisplayBalance(max, 6)
    } else {
      return getFullDisplayBalance(max)
    }
  }, [max, tokenName])

  const handleChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const val = e.currentTarget.value
      if (integer) {
        const text: string = val.replace(/^0+/g, '').replace(/[^\d]/g, '')
        setVal(text)
        return
      }
      setVal(val)
    },
    [setVal, integer],
  )

  const handleSelectMax = useCallback(() => {
    setVal(fullBalance)
  }, [fullBalance, setVal])

  return (
    <Modal>
      <ModalTitle text={`Deposit ${tokenName} Tokens`} />
      <TokenInput
        value={val}
        onSelectMax={handleSelectMax}
        onChange={handleChange}
        max={fullBalance}
        symbol={tokenName}
      />
      <ModalActions>
        <Button onClick={onDismiss}>Cancel</Button>
        <Button
          disabled={pendingTx || !(+val > 0) }
          onClick={async () => {
            setPendingTx(true)
            await onConfirm(val)
            setPendingTx(false)
            onDismiss && onDismiss()
          }}
        >{pendingTx ? 'Pending Confirmation' : 'Confirm'}</Button>
      </ModalActions>
    </Modal>
  )
}

export default DepositModal
